import { messageDetailsState } from './state'

import { fetchDetails } from './actions'

import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'

export const fetchDetailsCallback = ({ set }) => async idMessage => {
  set(messageDetailsState(idMessage), prev => ({
    ...prev,
    loading: true,
    error: undefined
  }))

  try {
    const messageDetails = await fetchDetails(idMessage)

    set(messageDetailsState(idMessage), prev => ({
      ...prev,
      ...messageDetails,
      loading: false
    }))
  } catch (error) {
    //  eslint-disable-next-line
    console.error('### error', error)

    logAppError({
      appError: error
    })

    set(messageDetailsState(idMessage), prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      loading: false
    }))
  }
}
